export default "__VITE_ASSET__CpZk8b8C__"